<template>
  <div class="meituanVerificationRecord">
    <div class="search_warp">
      <el-form class="search_form" :inline="true" :model="searchForm">
        <el-form-item label="手机号">
          <el-input class="search_form_input" v-model.trim="searchForm.phone" placeholder="请输入手机号" clearable />
        </el-form-item>
        <el-form-item label="验券医馆">
          <el-select class="search_form_select" v-model="searchForm.deptId" filterable clearable placeholder="全部医馆" :disabled="!['', '0', 0, -1].includes(deptId)">
            <el-option v-for="(dept, deptIndex) in deptList" :key="deptIndex" :label="dept.label" :value="dept.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="验券人">
          <el-select class="search_form_select" v-model="searchForm.verifyUserId" filterable clearable placeholder="全部">
            <el-option v-for="user in userList" :key="user.userId" :label="user.nickName" :value="user.userId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="验券时间">
          <el-date-picker
             class="search_form_daterange"
            v-model="searchForm.date"
            type="daterange"
            :editable="false"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="datePickerOptions"
            @change="handleDateChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="是否撤销验券">
          <el-select class="search_form_select" v-model="searchForm.revokeStatus" clearable placeholder="全部">
            <el-option label="是" :value="1" />
            <el-option label="否" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
          <el-button @click="exportReport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table_warp">
      <el-table v-loading="loading" :data="tableData" border>
        <el-table-column prop="dealTitle" label="商品名称" min-width="160" fixed="left" show-overflow-tooltip/>
        <el-table-column prop="meituanOrderId" label="订单号" min-width="180" fixed="left" />
        <el-table-column prop="voucherCode" label="券号" min-width="140" />
        <el-table-column prop="reservationId" label="预约单号" min-width="100"/>
        <el-table-column prop="meituanMobile" label="订单手机号" min-width="120"/>
        <el-table-column prop="patientMobile" label="患者手机号" min-width="120"/>
        <el-table-column prop="verifyTime" label="验券时间" min-width="160"/>
        <el-table-column prop="deptName" label="验券医馆" min-width="120"/>
        <el-table-column prop="verifyUserName" label="验券人" min-width="140"/>
        <el-table-column prop="orderNumber" label="门诊单号" min-width="180"/>
        <el-table-column prop="salesPersonName" label="开单人" min-width="120"/>
        <el-table-column prop="executeDoctorName" label="执行人" min-width="120"/>
        <el-table-column prop="orderAmount" label="订单金额" min-width="120"/>
        <el-table-column prop="merchantDiscountAmount" label="商家优惠金额" min-width="120"/>
        <el-table-column prop="platformCommission" label="平台佣金(含公益)" min-width="140"/>
        <el-table-column prop="actualIncomeAmount" label="美团结算金额" min-width="120"/>
        <el-table-column label="实收金额" min-width="120">
          <template slot-scope="scope">
            <span>{{ Math.round((scope.row.orderAmount - scope.row.merchantDiscountAmount) * 100) / 100 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cancelUserName" label="撤销人" min-width="120"/>
        <el-table-column prop="revokeStatus" label="是否撤销验券" min-width="120" fixed="right">
          <template slot-scope="scope">
            <span v-if="scope.row.revokeStatus === 0">未撤销</span>
            <span v-if="scope.row.revokeStatus === 1">已撤销</span>
            <span v-if="scope.row.revokeStatus === 2">已撤销(美团客服退费)</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.canRevoke" type="primary" size="mini" @click="revokeOpen(scope.row)">撤销核销</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        :current-page="searchForm.pageNum"
        :page-size="searchForm.pageSize"
        :total="total"
        layout="total, prev, pager, next"
        @current-change="pageNumChange"
      />
    </div>
    <!-- 撤销核销弹窗 -->
    <el-dialog
      class="revoke_dialog"
      title="撤销验券"
      :visible.sync="revokeMap.visible"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="revokeClose">
      <div class="revoke_content">
        <div class="revoke_tips">
          <span class="el-icon-warning-outline revoke_tips_icon"></span>
          <span class="revoke_tips_text">
            <template v-if="revokeMap.type === 0">撤销成功后，结果不可回退，请谨慎操作</template>
            <template v-if="revokeMap.type === 1">该订单已超过10分钟，患者只能在美团平台申请退费</template>
          </span>
        </div>
        <div class="revoke_info">
          <div class="revoke_title">
            <template v-if="revokeMap.type === 0">团购信息｜{{ revokeMap.name }}</template>
            <template v-if="revokeMap.type === 1">请确定美团平台已完成退费审核，再操作撤销</template>
          </div>
        </div>
      </div>
      <div slot="footer" class="revoke_footer">
        <el-button @click="revokeClose">取 消</el-button>
        <el-button type="primary" @click="revokeSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import req from '@/utils/request'
  import { debounce } from '@/utils/validateBase'

  function getDefaultVerifyDateRange () {
    const today = new Date()
    const start = new Date(today.getFullYear(), today.getMonth() - 2, 1)
    return [start.Format('yyyy-MM-dd'), today.Format('yyyy-MM-dd')]
  }

  export default {
    name: 'MeituanVerificationRecord',
    data() {
      return {
        loading: false,
        deptId: this.$session.get('deptId'),
        deptList: [],
        userList: [],
        datePickerMap: {
          firstSelectedDate: null
        },
        searchForm: {
          phone: '',
          deptId: '',
          verifyUserId: '',
          date: getDefaultVerifyDateRange(),
          revokeStatus: '',
          pageNum: 1,
          pageSize: 10
        },
        total: 0,
        tableData: [],
        revokeMap: {
          visible: false,
          type: 0, // 0: 未超过10分钟, 1: 超过10分钟
          name: '',
          voucherCode: ''
        }
      }
    },
    created () {
      this.init()
      this.getList()
    },
    computed: {
      datePickerOptions () {
        return {
          disabledDate: (date) => {
            if (!this.datePickerMap.firstSelectedDate) return false
            const startDate = new Date(this.datePickerMap.firstSelectedDate)
            const minDate = new Date(startDate)
            minDate.setMonth(minDate.getMonth() - 3)
            const maxDate = new Date(startDate)
            maxDate.setMonth(maxDate.getMonth() + 3)
            return date.getTime() < minDate.getTime() || date.getTime() > maxDate.getTime()
          },
          onPick: ({ maxDate, minDate }) => {
            if (!maxDate && minDate) {
              this.datePickerMap.firstSelectedDate = minDate
            } else {
              this.datePickerMap.firstSelectedDate = null
            }
          }
        }
      }
    },
    methods: {
      handleDateChange (val) {
        this.datePickerMap.firstSelectedDate = null
        if (!val || val.length !== 2 || !val[0] || !val[1]) return
        const start = new Date(val[0])
        const end = new Date(val[1])
        const maxEnd = new Date(start)
        maxEnd.setMonth(maxEnd.getMonth() + 3)
        if (end.getTime() > maxEnd.getTime()) {
          this.$nextTick(() => {
            this.searchForm.date = [val[0], maxEnd.Format('yyyy-MM-dd')]
          })
          this.$message.warning('验券时间范围最多可选择三个月')
        }
      },
      init () {
        this.deptList = sessionStorage.getItem('options') && JSON.parse(sessionStorage.getItem('options')) || []
        this.getUserList()

        if (!['', '0', 0, -1].includes(this.$session.get('deptId'))) {
          this.searchForm.deptId = this.$session.get('deptId')
        }
      },
      async getUserList () {
        const res = await req.get('/system/user/list', {
          deptId: 'all'
        })
        if (res.code === 200) {
          this.userList = res.rows || []
        }
      },
      async getList () {
        this.loading = true
        const res = await req.post('/physio/group-voucher/verification/page', {
          condition: {
            plat: 1,
            phone: this.searchForm.phone,
            deptId: this.searchForm.deptId,
            verifyUserId: this.searchForm.verifyUserId,
            beginVerifyTime: this.searchForm.date && this.searchForm.date[0] ? this.searchForm.date[0] : '',
            endVerifyTime: this.searchForm.date && this.searchForm.date[1] ? this.searchForm.date[1] : '',
            revokeStatus: this.searchForm.revokeStatus
          },
          pageIndex: this.searchForm.pageNum,
          pageSize: this.searchForm.pageSize
        })
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records && res.data.records.map(v => {
            v['canRevoke'] = v.revokeStatus === 0
            return v
          }) || []
          this.total = res.data.total
        }
      },
      pageNumChange (pageNum) {
        this.searchForm.pageNum = pageNum
        this.getList()
      },
      search () {
        this.searchForm.pageNum = 1
        this.getList()
      },
      reset () {
        this.searchForm = {
          phone: '',
          deptId: ['', '0', 0, -1].includes(this.$session.get('deptId')) ? '' : this.$session.get('deptId'),
          verifyUserId: '',
          date: getDefaultVerifyDateRange(),
          revokeStatus: '',
          pageNum: 1,
          pageSize: 10
        }
        this.getList()
      },
      exportReport: debounce(function () {
        req.downloadGet('/physio/group-voucher/verification/export', {
          plat: 1,
          phone: this.searchForm.phone,
          deptId: this.searchForm.deptId,
          verifyUserId: this.searchForm.verifyUserId,
          beginVerifyTime: this.searchForm.date && this.searchForm.date[0] ? this.searchForm.date[0] : '',
          endVerifyTime: this.searchForm.date && this.searchForm.date[1] ? this.searchForm.date[1] : '',
          revokeStatus: this.searchForm.revokeStatus
        }, { name: '美团订单核销记录' }).then(res => {})
      }, 1000, true),
      revokeOpen (row) {
        const verifyTimeStamp = row.verifyTime ? new Date(row.verifyTime).getTime() : 0
        const nowTimeStamp = Date.now()
        const diffTime = nowTimeStamp - verifyTimeStamp
        const diffTimeMinutes = Math.floor(diffTime / (60 * 1000))

        this.revokeMap.visible = true
        this.revokeMap.type = diffTimeMinutes <= 10 ? 0 : 1
        this.revokeMap.name = row.dealTitle
        this.revokeMap.voucherCode = row.voucherCode
      },
      revokeClose () {
        this.revokeMap.visible = false
        this.revokeMap.name = ''
        this.revokeMap.voucherCode = ''
      },
      async revokeSubmit () {
        const res = await req.post('/physio/group-voucher/revoke', {
          plat: 1,
          deptId: sessionStorage.getItem('deptId'),
          voucherCode: this.revokeMap.voucherCode,
          overTenMinutes: this.revokeMap.type === 1
        })
        if (res.code === 200) {
          this.$message.success('撤销成功')
        }
        this.revokeClose()
        this.getList()
      }
    }
  }
</script>

<style lang="less" scoped>
  .meituanVerificationRecord {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .search_warp {
    padding: 16px 16px 0;
  }

  .search_form {
    margin-top: -12px;
  }

  .search_form .el-form-item {
    margin-top: 12px;
    margin-bottom: 0;
  }

  .search_form .el-form-item /deep/ .el-form-item__label {
    line-height: 32px;
  }

  .search_form .el-form-item /deep/ .el-form-item__content {
    line-height: 32px;
  }

  .search_form_input {
    width: 140px;
  }

  .search_form_select {
    width: 140px;
  }

  .search_form_daterange {
    width: 240px;
  }

  .search_form_daterange /deep/ .el-range__close-icon {
    line-height: 24px;
  }

  .table_warp {
    flex: 1;
    padding: 16px;
    overflow: auto;
  }

  .pagination {
    margin-top: 16px;
    text-align: right;
  }

  .revoke_dialog /deep/ .el-dialog__header {
    padding: 12px 24px;
  }

  .revoke_dialog /deep/ .el-dialog__title {
    line-height: 24px;
    font-size: 16px;
    color: #1F2329;
  }

  .revoke_dialog /deep/ .el-dialog__headerbtn {
    top: 16px;
  }

  .revoke_dialog /deep/ .el-dialog__body {
    padding: 0;
  }

  .revoke_dialog /deep/ .el-dialog__footer {
    padding: 16px;
  }

  .revoke_tips {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 18px;
    width: 100%;
    height: 38px;
    background-color: #FFFBE8;
  }

  .revoke_tips_icon {
    font-size: 16px;
    color: #FE8F1F;
  }

  .revoke_tips_text {
    margin: 0 0 0 5px;
    line-height: 20px;
    font-size: 13px;
    color: #667182;
  }

  .revoke_info {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
  }

  .revoke_title {
    width: 100%;
    line-height: 20px;
    font-size: 14px;
    color: #000000;
  }
</style>